/** Human-readable labels; API enum values remain unchanged. */
export function enumLabel(value: string): string {
  const text = value.trim();
  if (/^(ngn|gbp|usd|eur)$/i.test(text)) return text.toUpperCase();
  if (!text || /^[A-Z]{2,4}$/.test(text)) return text;
  // Preserve authored labels, names and brands; normalize raw enum tokens only.
  if (!text.includes("_") && /[a-z]/.test(text) && /[A-Z]/.test(text)) return text;
  return text.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase());
}
